import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SignaturePad } from "@/components/SignaturePad";

export const useDisclaimer = (kind = "mlo") => {
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get("/auth/disclaimer", { params: { kind } }).then((r) => setD(r.data)).catch(() => {}); }, [kind]);
  return d;
};

export const DisclaimerFields = ({ disclaimer, agree, setAgree, name, setName, setSigImage }) => (
  <div className="space-y-3 rounded-lg border border-slate-200 bg-slate-50 p-3" data-testid="disclaimer-block">
    <div className="text-xs font-bold uppercase tracking-wider text-slate-600">{disclaimer?.title || "MLO Responsibility & Compliance Disclaimer"}</div>
    <ol className="max-h-44 list-decimal space-y-1.5 overflow-y-auto pl-4 text-xs leading-relaxed text-slate-700" data-testid="disclaimer-text">
      {(disclaimer?.text || []).map((t) => <li key={t}>{t}</li>)}
    </ol>
    <label className="flex items-start gap-2 text-xs font-semibold text-slate-800">
      <Checkbox checked={agree} onCheckedChange={(v) => setAgree(!!v)} data-testid="disclaimer-agree" className="mt-0.5" />
      I have read and agree to this disclaimer. My use of Elite Leads is my own responsibility.
    </label>
    <div>
      <Label htmlFor="sig" className="text-xs">Type your full legal name</Label>
      <Input id="sig" value={name} onChange={(e) => setName(e.target.value)} placeholder="Full legal name" className="mt-1 bg-white font-serif italic" data-testid="disclaimer-signature" />
    </div>
    <div>
      <Label className="text-xs">Signature</Label>
      <div className="mt-1"><SignaturePad onChange={setSigImage} /></div>
    </div>
  </div>
);
